import Vue from "vue";
import Company from "@/models/Company";

export default class CompanyApi {

    constructor(api, userApi) {
        this.api = api;
        this.userApi = userApi;
    }

    getMyCompany(callback, error) {
        this.userApi.get((user) => {
            this.get(user.companyId, (company) => {
                callback(company);
            }, error);
        });
    }

    get(id, callback, error) {
        this.api.getRaw((axios) => {
            axios.get("company/" + id).then((response) => {
                callback(new Company(response.data));
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        });
    }

    getAll(callback, error) {
        this.api.getRaw((axios) => {
            axios.get("company").then((response) => {
                callback(response.data.map((date) => new Company(date)));
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        });
    }

    all(callback, error) {
        this.getAll(callback, error);
    }

    moveUser(userId, companyId, callback, error) {
        this.api.getRaw((axios) => {
            axios.post("company/" + companyId + "/move/" + userId).then(() => {
                callback();
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

    update(id, data, callback, error) {
        this.api.getRaw((axios) => {
            axios.put("company/" + id, data).then(() => {
                callback();
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

    create(data, callback, error) {
        this.api.getRaw((axios) => {
            axios.post("company", data).then(() => {
                callback();
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

    delete(id, callback, error) {
        this.api.getRaw((axios) => {
            axios.delete("company/" + id).then(() => {
                callback();
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

}
